module.exports = __webpack_public_path__ + "img/account_pc_06.4cd94ccd.png";